module.exports = __webpack_public_path__ + "img/1164759.90ab4065.png";